<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" :class="!isDetail && 'isDetail'" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 48.551 65.85">
    <g id="yema2" transform="translate(-975.449 -2.001)">
      <path id="路径_5242" data-name="路径 5242" d="M-694.086,731.511l-19.1-7.866a1.544,1.544,0,0,0-1.179,0l-19.1,7.866a3.323,3.323,0,0,1-4.59-3.073v-59.2a3.324,3.324,0,0,1,3.324-3.324h41.9a3.324,3.324,0,0,1,3.324,3.324v59.2A3.323,3.323,0,0,1-694.086,731.511Z" transform="translate(1713.496 -663.914)" fill="var(--theme-color-1)"/>
      <text id="_01" data-name="01" transform="translate(983.449 46)" fill="#fff" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.isDetail {
  position: absolute;
  bottom: 20px;
  right: 0;
}
</style>
